module.exports = __webpack_public_path__ + "static/media/car.0bc9d038.svg";